import { useTranslation } from 'next-i18next';
import RoutePaths from 'src/config/RoutePaths';

const useTabs = () => {
    const { t } = useTranslation();

    return [
        {
            id: 'insights',
            name: t('article_category_insights'),
            href: RoutePaths.INSIGHTS,
        },
        {
            id: 'news',
            name: t('article_category_media'),
            href: RoutePaths.NEWS,
        },
        {
            id: 'events',
            name: t('article_category_events'),
            href: RoutePaths.EVENTS,
        },
    ];
};

export default useTabs;
